exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n_/ Links Cascading Style Sheets\n_/\n_/ Created by NICE+DAY, Inc. [07/10/2018]\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n*/\n/*\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n_/ Starbright Cascading Style Sheets Property\n_/\n_/ Created by NICE+DAY, Inc. [18/08/2018]\n_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/\n*/\n/* ////////////////////////////////////\n// common setting\n//////////////////////////////////// */\n#container-wrapper {\n  width: 100%; }\n\n.contents-wrapper {\n  width: 100%;\n  -ms-flex-line-pack: center;\n      align-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/pages/links/links.component.scss
// module id = ../../../../../src/app/pages/links/links.component.scss
// module chunks = main